export class AdvanceFilter {
  salaryType: string;
  jobType: string;
  workType: number;
}
